import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, distinctUntilChanged, startWith, takeUntil } from 'rxjs';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-deleted-cases-filter',
  templateUrl: './deleted-cases-filter.component.html',
  styleUrls: ['./deleted-cases-filter.component.scss'],
  imports: [MatCheckbox, FormsModule, ReactiveFormsModule],
})
export class DeletedCasesFilterComponent implements OnInit, OnDestroy {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  readonly show_deleted = new FormControl<boolean | null>(null);

  ngOnInit(): void {
    this.payeeCasesService.show_deleted
      .pipe(
        startWith(this.payeeCasesService.show_deleted.value),
        takeUntil(this.destroy),
        distinctUntilChanged(),
      )
      .subscribe((v) =>
        this.show_deleted.patchValue(!!v, { emitEvent: false }),
      );

    this.show_deleted.valueChanges
      .pipe(takeUntil(this.destroy), distinctUntilChanged())
      .subscribe((v) => this.payeeCasesService.show_deleted.next(v ? 1 : null));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
